import { Expose } from "class-transformer";

export class UpdateConsumableHasExternalReferenceDto {
  @Expose()
  externalReference: string;

  @Expose()
  supplierId: string;
}
